export default "__VITE_ASSET__ttJ5n2Mz__"